// {
//   "user_id": "66614df5966ed02f7a77de9c",
//   "task_type": "personal", //"personal", "work", "group", "habits", "family","all",
//   //"period": "in_day", //убрал
//   "repeat": "noRepeat", //"noRepeat", "everyday", "everyWeek", "everyMonth", "everyYear", "chooseDays"
//   //"days_of_week": ["Monday", "Wednesday", "Friday"], //убрал пока
//   "start_date": "2025-01-20T00:00:00.000Z",
//   "planned_end_date": "2025-01-20T00:00:00.000Z",
//   "actual_end_date": "2025-01-19T00:00:00.000Z",
//   //"next_planned_date": "2025-01-22T00:00:00.000Z", убрал пока, нужно для регулярных задач
//   //"execution_days": 7, //что это
//   "content": "Complete daily workout",
//   //"category": "health", //убрал
//   //"planned_time": 60, //убрал 
//   //"actual_time": 50,  //убрал
//   "priority": 2, //1, 2, 3 высокий низ средн
//   "status": "completed", //"in_process"
//   //"completed_in_time": true, //временно убрал, нужно для статистики, в срок или нет выполнена
//   "notifications": {
//     "channels": ["telegram"], //останется только тг без сферума
//     "schedule": ["1_day_before"] //
//   },
//   "linkDoc": "", //добавил новое
//   "linkChat": "", //добавил новое, будет для групповой актуально
// },

export const tasks = [
  {
    "id": "task_101",
    "user_id": "66614df5966ed02f7a77de9c",
    "task_type": "work",
    "repeat": "noRepeat",
    "time_start": "2025-06-05T09:00:00.000Z",
    "time_end": "2025-06-05T11:00:00.000Z",
    "time_end_actual": null,
    "content": "Созвон с партнерами по проекту",
    "priority": 1,
    "status": "in_process",
    "notifications": {
      "channels": ["telegram"],
      "schedule": ["1_day_before", "1_hour_before"]
    },
    "linkDoc": "",
    "linkChat": "https://t.me/project_team_chat"
  },
  {
    "id": "task_102",
    "user_id": "66614df5966ed02f7a77de9c",
    "task_type": "personal",
    "repeat": "everyday",
    "time_start": "2025-06-01T07:00:00.000Z",
    "time_end": "2025-06-30T07:30:00.000Z",
    "time_end_actual": null,
    "content": "Проверка почты и планирование дня",
    "priority": 2,
    "status": "in_process",
    "notifications": {
      "channels": ["telegram"],
      "schedule": ["0_day_before"]
    },
    "linkDoc": "",
    "linkChat": ""
  },
  {
    "id": "task_103",
    "user_id": "66614df5966ed02f7a77de9c",
    "task_type": "work",
    "repeat": "noRepeat",
    "time_start": "2025-06-07T00:00:00.000Z",
    "time_end": "2025-06-14T00:00:00.000Z",
    "time_end_actual": null,
    "content": "Финализировать коммерческое предложение",
    "priority": 1,
    "status": "in_process",
    "notifications": {
      "channels": ["telegram"],
      "schedule": ["2_days_before"]
    },
    "linkDoc": "https://docs.google.com/document/proposal_v3",
    "linkChat": ""
  },
  {
    "id": "task_104",
    "user_id": "66614df5966ed02f7a77de9c",
    "task_type": "personal",
    "repeat": "weekly",
    "time_start": "2025-06-02T18:00:00.000Z",
    "time_end": "2025-06-02T19:00:00.000Z",
    "time_end_actual": null,
    "content": "Разобрать входящие задачи в Notion",
    "priority": 3,
    "status": "in_process",
    "notifications": {
      "channels": ["telegram"],
      "schedule": ["1_hour_before"]
    },
    "linkDoc": "",
    "linkChat": ""
  },
  {
    "id": "task_105",
    "user_id": "66614df5966ed02f7a77de9c",
    "task_type": "work",
    "repeat": "noRepeat",
    "time_start": "2025-06-06T10:00:00.000Z",
    "time_end": "2025-06-06T12:00:00.000Z",
    "time_end_actual": null,
    "content": "Подготовить презентацию для внутреннего совещания",
    "priority": 2,
    "status": "in_process",
    "notifications": {
      "channels": ["telegram"],
      "schedule": ["1_day_before", "2_hours_before"]
    },
    "linkDoc": "https://docs.google.com/presentation/team_meeting",
    "linkChat": ""
  }
];